import { render, staticRenderFns } from "./DashboardOverviewPage.vue?vue&type=template&id=1cc6596d&scoped=true&"
import script from "./DashboardOverviewPage.vue?vue&type=script&lang=js&"
export * from "./DashboardOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOverviewPage.vue?vue&type=style&index=0&id=1cc6596d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc6596d",
  null
  
)

export default component.exports